import {Component, OnInit, ViewChild} from '@angular/core';
import {StatisticsApiService} from '../../services/api/statistics/statistics-api.service';
import {ReportSelectionService} from '../services/reportSelection.service';
import {GraphAreaPanelComponent} from './graph-area-panel/graph-area-panel.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';

@Component({
  selector: 'graphs',
  templateUrl: './graphs.component.html',
  styleUrls: ['./graphs.component.scss']
})
export class GraphsComponent implements OnInit {

  externalData: any;
  selectedReport: any;
  dataReady = false;

  @ViewChild(GraphAreaPanelComponent, {static: false})
  graphAreaPanel: GraphAreaPanelComponent;

  constructor(private statisticsApiService: StatisticsApiService,
              private reportSelectionService: ReportSelectionService,
              private loaderService: LoaderService) {
  }

  refreshChart(chartData): void {
    this.graphAreaPanel.refreshChart(chartData.identifier, chartData.type);
  }

  ngOnInit(): void {
    this.storeRepositoryData();
  }

  initialize(): void {
    this.selectedReport = this.reportSelectionService.getReportSelection();
    this.getExternalData();
  }

  getExternalData(): void {
    this.loaderService.showMainContainer();
    this.statisticsApiService.getExternalData().then(data => {
      this.externalData = {
        nodes: data[0],
        pCons: data[1],
        connections: data[2],
        routers: data[3],
        routingRules: data[4].routingRules,
        routingGroups: data[4].routingGroups,
        callsQuotas: data[5].elements,
        resourceGroups: data[6].elements,
        customers: data[7].elements,
        voipPeers: data[8]
      };
      this.loaderService.hideMainContainer();
    }).catch(() => {
      this.loaderService.hideMainContainer();
    });
  }

  onReportSelected(report): void {
    this.selectedReport = report;
  }

  storeRepositoryData(): any {
    if (!!sessionStorage.getItem('ReportRepository')) {
      this.dataReady = true;
      this.initialize();
      return;
    }

    this.statisticsApiService.getRepository()
      .then((repository) => {
        sessionStorage.setItem('ReportRepository', JSON.stringify(repository));
        this.dataReady = true;
        this.initialize();
      })
      .catch(() => {
      });
  }
}
